import React from 'react';
import PropTypes from 'prop-types';
import { strings } from '../../../localization';
import { REPORT_BY_TYPES } from './SafetyScore';

export default class SafetyScoreHeader extends React.PureComponent {

    static propTypes = {
        stateDivergedFromDefaults: PropTypes.bool.isRequired,
        selectedTimePeriodType: PropTypes.string.isRequired,
        selectedReportBy: PropTypes.string.isRequired,
        availableEntities: PropTypes.array.isRequired,
        availableEventsFactors: PropTypes.array.isRequired,
        progressPercentageComplete: PropTypes.number.isRequired,
        onOptionsClick: PropTypes.func.isRequired
    };

    render() {

        const selectedEntities = this.props.availableEntities.filter(entity => entity.selected);
        const selectedEntitiesLabel = this.props.selectedReportBy === REPORT_BY_TYPES.DRIVER ? strings.score_drivers : strings.score_vehicles;
        const localizedTimePeriod = strings["score_selected_time_period_" + this.props.selectedTimePeriodType.toLowerCase()];
        const localizedReportBy = this.props.selectedReportBy === REPORT_BY_TYPES.DRIVER ? strings.event_summary_driver_name_label : strings.event_summary_vehicle_name_label;
        const localizeScoreFactorsLabel = this.props.stateDivergedFromDefaults ? strings.score_events_factors_type_custom : strings.score_events_factors_type_default;

        return (
            <header className="score-header">
                <h2>{strings.score_header}</h2>

                <div className="score-criteria-summary">
                    <div>
                        <h6>{strings.score_current_score_criteria}</h6>
                        <span>{strings.score_period_label} {localizedTimePeriod}</span>
                        <span>{selectedEntitiesLabel + ":"} {strings.formatString(strings.reports_filter_x_selected, selectedEntities.length)}</span>
                        <span>{strings.score_events_factors_label} {localizeScoreFactorsLabel}</span>
                        <span>{strings.score_reporting_by_label} {localizedReportBy}</span>
                    </div>
                    <div>
                        <button
                            onClick={this.props.onOptionsClick}
                            className="btn btn-blue"
                        >
                            {strings.action_options}
                        </button>
                    </div>
                </div>
                <hr
                    className='progress-bar'
                    style={{
                        // main animation: line grows and pulsates (see also coaching-progress-bar-pulse in coaching.scss)
                        width: this.props.progressPercentageComplete + "%",
                        // secondary animation: line disappears gradually when progress is complete (i.e. shrinks to 0 width; see .progress-bar transition in coaching.scss)
                        height: this.props.progressPercentageComplete < 100 ? "0.1429rem" : "0"
                    }}
                />
            </header>
        );
    }
}